import React from 'react';
import InfoDialog from 'swag-client-common/components/info/info-dialog';
export default function InternetExplorerPopup(props) {
  const {
    onClose
  } = props;
  return /*#__PURE__*/React.createElement(InfoDialog, {
    subHeader: "Hey!",
    header: "",
    content: content,
    onRequestClose: onClose,
    showCloseButton: true,
    open: true
  });
}
const content = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Looking forward to helping you out with your swag order! We are now working on compatibility with Internet Explorer. Please use a different browser. Looking forward to working with you!"), /*#__PURE__*/React.createElement("p", null, "For better experience we recommend using the latest versions of Chrome, Safari or Firefox."));